import { createSelector } from 'reselect';

import { selectLoanApplication } from './loanApplication.selectors';

export const selectLoanCicReasons = createSelector(
  selectLoanApplication,
  ({ loanCicReasons }) => loanCicReasons || [],
);

export const selectHasLoanCicReasons = createSelector(
  selectLoanCicReasons,
  loanCicReasons => !!loanCicReasons.length,
);
